<template>
  <div class="user-image-container">
    <ImageUploaderModal
      v-if="isImageUploaderModalShowing"
      :imageObject.sync="imageObject"
      :imageViewSize="imageViewSize"
      :onCloseModal="onCloseImageUploaderModal" />
    <div class="user-image-header">
      <h5 class="name">ภาพประจำตัว</h5>
      <div class="actions">
        <button
          type="button"
          class="btn btn-link p-0"
          @click.stop="chooseImage">
          เลือกภาพ
        </button>
      </div>
    </div>
    <div class="user-image-preview">
      <ImageView
        :source="image"
        :imageSize="imageViewSize"
        aspectRatio="1:1"
        emptyMessageText="ไม่มีภาพประจำตัว" />
      <small class="help-text">
        ขนาดภาพที่เหมาะสม 640x640
      </small>
    </div>
  </div>
</template>

<script>
import ImageView from '@/image/ImageView.vue';
import ImageUploaderModal from '@/image/ImageUploaderModal.vue';

export default {
  props: {
    image: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    ImageView,
    ImageUploaderModal,
  },
  data() {
    return {
      imageViewSize: 'cover320w320h',
      imageObject: null,
      isImageUploaderModalShowing: false,
    };
  },
  watch: {
    imageObject(newValue) {
      this.$emit('update:image', newValue);
      this.onCloseImageUploaderModal();
    },
  },
  methods: {
    chooseImage() {
      this.onToggleImageUploaderModal();
    },
    onCloseImageUploaderModal() {
      this.isImageUploaderModalShowing = false;
    },
    onToggleImageUploaderModal() {
      this.isImageUploaderModalShowing = !this.isImageUploaderModalShowing;
    },
    getImageSource() {
      if (this.image) {
        return this.image;
      }
      return this.defaultImage;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.user-image-header {
  display: flex;
  align-items: flex-end;

  .name {
    font-weight: normal;
    color: $body-color;
    font-family: $font-family-CSPrajad;
    font-size: $font-size-base;
  }

  .actions {
    margin-left: auto;
    margin-bottom: $spacer * 0.35;
    .btn {
      &:last-child {
        padding-right: 0;
      }
    }
  }
}
</style>
